import React from 'react';

import { Box, DialogContentText } from '@material-ui/core';
import styled from 'styled-components';

import { CustomDialog } from 'src/components';

interface IConfirmModal {
  openConfirmModal: { action: string; open: boolean };
  handleClose: () => void;
  onSubmit: () => void;
}
export const DialogContentTextStyled = styled(DialogContentText)(() => ({
  fontSize: 16,
  fontWeight: 400,
  color: 'rgba(0, 0, 0, 0.6)',
}));
function CMSConfirmModal({ openConfirmModal, handleClose, onSubmit }: IConfirmModal) {
  let text;

  if (openConfirmModal.action === 'cancel') {
    text = 'Are you sure you want to cancel?';
  }
  if (openConfirmModal.action === 'save') {
    text = 'Are you sure you want to save this change?';
  }
  return (
    <CustomDialog
      open={openConfirmModal.open}
      handleClose={handleClose}
      onSubmit={onSubmit}
      cancelText="No"
      submitText="Yes"
      isConfirmPopup={true}
    >
      <Box alignSelf="center" display="flex" flex={1} justifyContent="center" alignItems="center" textAlign="center">
        <DialogContentTextStyled>{text}</DialogContentTextStyled>
      </Box>
    </CustomDialog>
  );
}

export default CMSConfirmModal;
